<template>
  <div
    v-if="isQuickLogin"
    class="quick-login"
  >
    <h1>
      <i class="sprite-login sprite-login-link" />检测到您上次登录账号，<em>点击头像</em>一键登录
    </h1>
    <div class="user-record-list">
      <div
        v-for="(item, index) in recentLoginList"
        :key="index"
        class="user-record"
        :class="{ 'user-record-selected': index === 0 }"
        @click="commitQuickLogin(index)"
      >
        <div class="user-record-lt">
          <div class="avatar-wrap">
            <div
              v-if="!item.avatar"
              class="not-login-avatar sprite-login sprite-login-avatar"
            />
            <img
              v-else
              :src="item.avatar"
              class="avatar"
            >
            <i
              v-if="item.is_vip"
              class="sprite-login sprite-login-vip-logo vip"
            />
          </div>
          <div class="user-name-wrap">
            <p class="user-name">
              {{ item.nickname }}
            </p>
            <span
              v-if="registerFrm[item.register_frm]"
              class="register-frm"
            >{{
              registerFrm[item.register_frm]
            }}</span>
          </div>
        </div>
        <span
          class="del"
          title="删除上次登录信息"
          @click.stop="removeUserInfo(index)"
        >
          <i class="sprite-login sprite-login-del" />
        </span>
      </div>
    </div>
    <div class="quick-login-ft">
      <p
        class="other"
        @click="giveUpQuickLogin"
      >
        使用其他账号登录
      </p>
    </div>
  </div>
</template>

<script>
import { getToken, exchangeToken } from '@/api/login'
import { getRecentLoginList, removeRecentLoginList, getUnionLoginList, getDubaLoginList, getProductLoginList } from '@/utils/cache'
import login from '@/client/modules/login.js'
import common from '@/client/modules/common.js'
import * as LoginHandler from '@/services/login/loginHandler.js'
import { SDK_PRODUCT, REGISTER_FRM, REPORT_LOGIN_TYPE, REPORT_PARAMS } from '@/config/dataMap'
import { arrUnique } from '@/utils/shared.js'

/** 二维码是否加载 */
const QRCODE_LOAD = {
  /** 拒绝加载 */
  rejectLoad: false,
  /** 可以加载 */
  resolveLoad: true
}

export default {
  name: 'QuickLogin',
  data () {
    return {
      isQuickLogin: false,
      recentLoginList: [],
      registerFrm: REGISTER_FRM,
    }
  },
  computed: {
    isSourcePrint () {
      return this.$route.query?.custom === '1' && REPORT_PARAMS.show_from === '6031'
    },
  },
  mounted () {
    if (this.isSourcePrint) {
      this.isQuickLogin = false
      return
    }

    this.getRecentList()
    this.exchangeToken()
  },

  methods: {

    giveUpQuickLogin () {
      this.isQuickLogin = false
      this.emitLoopOfficialAccount(QRCODE_LOAD.resolveLoad)
      this.reportClick({ click: 21, login_type: REPORT_LOGIN_TYPE.wechat })
    },

    // 获得登录列表
    /* eslint-disable-next-line require-await */
    async getRecentList () {
      const recentListFromWeb = getRecentLoginList()
      const unionLoginList = getUnionLoginList() // 客户端登录历史列表
      const dubaLoginList = getDubaLoginList()
      const productLoginList = getProductLoginList()

      let recentListFromClient = [
        ...unionLoginList,
        ...dubaLoginList,
        ...productLoginList
      ]
      recentListFromClient = arrUnique(recentListFromClient, 'open_id') // 去重

      this.recentLoginList = this.handleRecentList(
        recentListFromWeb,
        recentListFromClient
      )

      let status = QRCODE_LOAD.rejectLoad
      if (this.recentLoginList.length === 0) {
        status = QRCODE_LOAD.resolveLoad
      }
      this.emitLoopOfficialAccount(status)
    },

    handleRecentList (recentListFromWeb, recentListFromClient) {
      const ownPid = SDK_PRODUCT.id
      // 合并列表
      const mergedList = recentListFromClient

      // recentListFromWeb, recentListFromClient合并&排重
      recentListFromWeb.forEach((item, index) => {
        if (this.isRecentListFromWebInClientList(item, recentListFromClient)) {
          removeRecentLoginList(index)
        } else {
          item.pid = ownPid
          mergedList.push(item)
        }
      })

      // 优先级处理: vip > 普通用户
      const vipList = []
      const commonList = []
      mergedList.forEach((item) => {
        if (this.isVip(item)) {
          item.is_vip = 1
          vipList.push(item)
        } else {
          commonList.push(item)
        }
      })

      // 自己产品的vip
      const ownVipList = []
      const otherVipList = []
      vipList.forEach((item) => {
        if (item.pid === ownPid) {
          ownVipList.push(item)
        } else {
          otherVipList.push(item)
        }
      })

      // 时间排序
      ownVipList.sort(this.sortByTime)
      otherVipList.sort(this.sortByTime)

      // 自己产品的普通会员
      const ownCommonList = []
      const otherCommonList = []
      commonList.forEach((item) => {
        if (item.pid === ownPid) {
          ownCommonList.push(item)
        } else {
          otherCommonList.push(item)
        }
      })

      // 时间排序
      ownCommonList.sort(this.sortByTime)
      otherCommonList.sort(this.sortByTime)
      const ret = [
        ...ownVipList,
        ...otherVipList,
        ...ownCommonList,
        ...otherCommonList
      ]

      return ret.slice(0, 3)
    },

    isVip (userInfo) {
      return userInfo && userInfo.vip_type && userInfo.vip_type != '0'
    },

    sortByTime (a, b) {
      const timeA = a.login_time || 0
      const timeB = b.login_time || 0
      return timeB - timeA
    },

    isRecentListFromWebInClientList (item, recentListFromClient) {
      let flag = false
      recentListFromClient.forEach((clientItem) => {
        if (item.open_id === clientItem.open_id) {
          flag = true
        }
      })
      return flag
    },

    /** 快速登录 */
    commitQuickLogin (index) {
      this.reportClick({ click: 20, login_type: REPORT_LOGIN_TYPE.quickLogin })
      login.REPORT.reportLoginPageResult({
        result: 3,
        reason: '',
        login_type: REPORT_LOGIN_TYPE.quickLogin,
      })
      const loginItem = this.recentLoginList[index]
      LoginHandler.quickLogin({
        token: loginItem.token,
        userInfo: loginItem,
      }).then((data) => {
        this.$emit('emitLoginRespond', data, REPORT_LOGIN_TYPE.quickLogin)
      })
    },

    exchangeToken () {
      if (this.recentLoginList.length === 0) return

      const promiseArr = []
      const ownPid = SDK_PRODUCT.id
      this.recentLoginList.forEach((item) => {
        // 如果不是当前产品的账号, 则要更换pid
        if (item.pid !== ownPid) {
          promiseArr.push(
            exchangeToken({
              from: item.pid,
              source_token: item.token,
              source_open_id: item.open_id,
            })
          )
        }
      })

      Promise.all(promiseArr).then((resList) => {
        resList.forEach((res) => {
          if (!res || !res.open_id) {
            return
          }

          const index = this.findIndexOfList(res.open_id)

          if (!res.resp_common || res.resp_common.ret !== 0) {
            this.delRecentLoginListCache(index)
            this.recentLoginList.splice(index, 1)
          } else {
            this.recentLoginList[index].token = res.token
            this.recentLoginList[index].open_id = res.open_id
          }
        })

        if (this.recentLoginList.length > 0) {
          this.checkTokenForQuickLogin()
        }
      })
    },

    findIndexOfList (open_id) {
      let index = -1
      this.recentLoginList.forEach((item, recordIndex) => {
        if (item.open_id === open_id) {
          index = recordIndex
        }
      })
      return index
    },

    delRecentLoginListCache (index) {
      const userInfo = this.recentLoginList[index]
      const recentLoginList = getRecentLoginList()

      // 删除cookie
      recentLoginList.forEach((item, recordIndex) => {
        if (item.open_id === userInfo.open_id) {
          removeRecentLoginList(recordIndex)
        }
      })
    },

    // 检查token可快速登录
    checkTokenForQuickLogin () {
      const promiseArr = []
      const copyRecentLoginList = [...this.recentLoginList]
      this.recentLoginList.forEach((item) => {
        promiseArr.push(
          getToken({
            common: {
              token: item.token,
              open_id: item.open_id,
            },
          })
        )
      })

      Promise.all(promiseArr).then((resList) => {
        resList.forEach((res, resIndex) => {
          const open_id = copyRecentLoginList[resIndex].open_id
          const index = this.findIndexOfList(open_id)
          if (!res || !res.resp_common || res.resp_common.ret !== 0) {
            this.delRecentLoginListCache(index)
            this.recentLoginList.splice(index, 1)
          }
        })

        if (this.recentLoginList.length > 0) {
          this.isQuickLogin = true
          this.reportShow(REPORT_LOGIN_TYPE.quickLogin)
        }
      })
    },

    /** 通知 轮询公众号接口，有缓存用户token不轮询 */
    emitLoopOfficialAccount (status) {
      this.$emit('emitLoopOfficialAccount', status)
    },

    removeUserInfo (index) {
      const userInfo = this.recentLoginList[index]
      const openid = userInfo.open_id
      let login_type = 0

      this.delRecentLoginListCache(index)

      // 删除显示的账号列表
      this.recentLoginList.splice(index, 1)
      if (this.recentLoginList.length <= 0) {
        this.isQuickLogin = false
        this.emitLoopOfficialAccount(QRCODE_LOAD.resolveLoad)
        login_type = REPORT_LOGIN_TYPE.wechat
      }

      this.reportClick({ click: 22, login_type })
      // 通知客户端删除用户记录
      common.API.client_deleteUser({ openid })
    },

    reportClick (data) {
      this.$emit('emitReportClick', data)
    },

    reportShow (loginType) {
      this.$emit('emitReportShow', loginType)
    }
  },
}
</script>

<style scoped lang="scss">
@import '@/assets/css/sprite-login.scss';
.quick-login {
  position: relative;
  width: 282px;
  height: 430px;
  margin: 0 auto;
  text-align: center;
  h1 {
    color: #797979;
    font-size: 16px;
    line-height: 30px;
    text-align: left;
    .sprite-login-link {
      margin-right: 10px;
    }
  }
  em {
    color: #de461e;
    font-style: normal;
    margin: 0 4px;
  }
  .user-record-list {
    margin-top: 24px;
  }
  .user-record {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #f4f6fa;
    padding: 10px 12px;
    margin-bottom: 10px;
    border-radius: 4px;
    cursor: pointer;
    height: 80px;
    box-sizing: border-box;
    &:hover {
      background-color: #dfe1e6;
    }
    .user-record-lt {
      display: flex;
      align-items: center;
    }
    .avatar-wrap {
      position: relative;
      width: 72px;
      height: 72px;
      margin-right: 16px;
      .not-login-avatar,
      .avatar {
        transform: scale(0.9);
        width: 100%;
        height: 100%;
        border-radius: 50%;
        display: block;
        cursor: pointer;
      }
      .vip {
        position: absolute;
        right: -10px;
        bottom: 0;
        width: 30px;
        height: 30px;
        cursor: pointer;
      }
    }
    .user-name-wrap {
      text-align: left;
      .user-name {
        font-size: 14px;
        color: #797979;
        margin-bottom: 4px;
      }
      .register-frm {
        display: inline-block;
        padding: 0 4px;
        line-height: 14px;
        border: 1px solid #c4c4c4;
        font-size: 11px;
        color: #929292;
        border-radius: 2px;
      }
    }
    .del {
      width: 24px;
      height: 24px;
      overflow: hidden;
      cursor: pointer;
      i {
        position: relative;
      }
      &:hover {
        i {
          left: -24px;
        }
      }
      &:active {
        i {
          left: -48px;
        }
      }
    }
  }
  .user-record-selected {
    background-color: #dfe1e6;
  }
  .quick-login-ft {
    margin-top: 33px;
    .other {
      margin-top: 25px;
      text-decoration: underline;
      cursor: pointer;
      color: #575757;
      font-size: 14px;
      font-weight: bold;
    }
  }
}
</style>
